export enum UserTypeEnum {
	None = 0,
	Admin = 1,
	Supplier = 2,
	Server = 3,
	Application = 4
}

export const UserTypeList = [
	{ name: "Ipsos AD", userType: UserTypeEnum.Admin },
	{ name: "Supplier", userType: UserTypeEnum.Supplier },
	{ name: "Server", userType: UserTypeEnum.Server },
	{ name: "Application", userType: UserTypeEnum.Application },
];
